import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import { RevealOnScroll } from "./Reveal";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/testimonials").then((r) => setItems(r.data)).catch(() => {}); }, []);

  return (
    <section data-testid="testimonials-section" className="section-y-lg bg-navy border-t border-white/5">
      <div className="container-editorial">
        <div className="grid grid-cols-12 gap-8 md:gap-16 mb-20 md:mb-28">
          <div className="col-span-12 md:col-span-7">
            <motion.span
              initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }}
              viewport={{ once: true, amount: 0.6 }}
              transition={{ duration: 1.2, ease: [0.19, 1, 0.22, 1] }}
              className="block h-px bg-[#C5A059] w-14 mb-8 origin-left"
            />
            <div className="overline text-[#C5A059] mb-6">In Their Words</div>
            <RevealOnScroll
              element="h2"
              className="font-display text-5xl md:text-6xl leading-[0.95] tracking-tight"
              lines={["The people who", "chose <em>Maklan</em>."]}
            />
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-x-16 md:gap-x-24 gap-y-20 md:gap-y-28">
          {items.map((t, i) => (
            <motion.figure
              key={t.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 1.2, delay: (i % 2) * 0.15, ease: [0.19, 1, 0.22, 1] }}
              className={`${i % 2 === 1 ? "md:mt-32" : ""}`}
              data-testid={`testimonial-${i}`}
            >
              <div className="font-display text-7xl text-[#C5A059]/40 leading-none">"</div>
              <blockquote className="font-display italic text-2xl md:text-3xl leading-[1.35] text-white/90 mt-4">
                {t.quote}
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-5">
                <span className="w-11 h-11 rounded-full bg-white/5 border border-white/10 flex items-center justify-center font-display text-[#C5A059] text-lg">
                  {t.name.charAt(0)}
                </span>
                <div>
                  <div className="text-white text-sm">{t.name}</div>
                  <div className="text-white/50 text-[10px] tracking-[0.28em] uppercase mt-1">{t.role} · {t.location}</div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
